import { ReactNode, useEffect } from 'react'

import { isFinanceReport } from 'app/dataTypes/reports/finances'

import { useFinancesReportsEnabled } from './useFinancesReportsEnabled'

type Props = {
  children: ReactNode
  report: string
  fallback?: ReactNode
  onReportDisabled?: () => void
}

const IsReportEnabled = ({ children, report, fallback, onReportDisabled }: Props) => {
  const { reportsEnabled, loading } = useFinancesReportsEnabled()
  const enabled = isFinanceReport(report) && reportsEnabled.includes(report)

  useEffect(() => {
    if (onReportDisabled && !loading && !enabled) {
      onReportDisabled()
    }
  }, [loading, enabled]) // eslint-disable-line react-hooks/exhaustive-deps

  if (loading && fallback) {
    return fallback
  }

  if (loading || !enabled) {
    return null
  }

  return children
}

export default IsReportEnabled
